import { ApplicationFormField } from "@prisma/client";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

export function useApplicationFormValidateMutation() {
  return useMutation<
    ApplicationFormField,
    null,
    {
      formInstanceId: string;
      applicationId: string;
      isValid: boolean;
    },
    () => void
  >(({ formInstanceId, applicationId, isValid }) =>
    axios.post(
      `/api/application/${applicationId}/form/${formInstanceId}/validate`,
      {
        isValid,
      }
    )
  );
}
